import { BANK_CODES } from '@js/constants/banks';
import { BOOLEAN } from '@js/constants/options';

import { reduce } from '@/components/Form/javascripts/codes';

import GROUPS from './javascripts/groups';

export const ATTACHMENTS_COUNT = 8;
export const MAX_ZERO_KM_MILEAGLE = 250;

export const REPEATING_RULES = {
  ALWAYS_VISIBLE: reduce(BANK_CODES, [
    [{ rule: 'required' }],
  ]),
};

export const VEHICLE_SCHEMA = {
  name: {
    group: null,
    label: 'Veículo',
    description: 'Escolha um veículo',
    domain: 'grouped_vehicle_model',
    validations: [{
      type: 'blank',
    }],
    rules: REPEATING_RULES.ALWAYS_VISIBLE,
  },
  manufacture_year: {
    group: null,
    label: 'Ano de fabricação',
    description: 'Selecione',
    validations: [{
      type: 'blank',
    }],
    options: [],
    rules: REPEATING_RULES.ALWAYS_VISIBLE,
  },
  model_year: {
    group: null,
    label: 'Ano do modelo',
    description: 'Selecione',
    validations: [{
      type: 'blank',
    }, {
      type: 'greater_than_or_equal_to',
      count: 0,
    }],
    options: [],
    rules: REPEATING_RULES.ALWAYS_VISIBLE,
  },
  vehicle_model_id: {
    group: null,
    label: 'Modelo do veículo',
    domain: 'vehicle_model',
    description: 'Escolha um modelo',
    validations: [{
      type: 'blank',
    }],
    options: [],
    rules: REPEATING_RULES.ALWAYS_VISIBLE,
  },
};

function attachment(item, index) {
  return {
    remote_file_id: {
      group: null,
      label: `Arquivo #${index + 1} do veículo`,
      description: 'Arquivo original',
      validations: [],
      rules: REPEATING_RULES.ALWAYS_VISIBLE,
    },
    original_filename: {
      group: null,
      label: `Nome da foto #${index + 1} do veículo`,
      description: 'Nome original do anexo',
      validations: [],
      rules: REPEATING_RULES.ALWAYS_VISIBLE,
    },
  };
}

export default {
  vehicle: {
    group: null,
    label: GROUPS.INFORMATION.title,
    description: GROUPS.INFORMATION.subtitle,

    fields: {
      store_id: {
        group: GROUPS.INFORMATION,
        label: 'Loja',
        description: 'Selecione',
        domain: 'stores',
        validations: [{
          type: 'blank',
        }],
        rules: REPEATING_RULES.ALWAYS_VISIBLE,
      },

      ...VEHICLE_SCHEMA,

      price_cents: {
        group: GROUPS.INFORMATION,
        label: 'Valor do veículo',
        description: 'R$ 0,00',
        mask: {
          type: 'monetize',
        },
        validations: [{
          type: 'greater_than',
          count: 0,
        }, {
          type: 'blank',
        }],
        rules: REPEATING_RULES.ALWAYS_VISIBLE,
      },

      license_plate_code: {
        group: GROUPS.INFORMATION,
        label: 'Placa',
        description: 'XXX-0000',
        validations: [],
        rules: REPEATING_RULES.ALWAYS_VISIBLE,
      },

      km_mileage: {
        group: GROUPS.INFORMATION,
        label: 'Quilometragem',
        description: 'Exemplo: 999km',
        mask: {
          type: 'monetize',
          prefix: '',
          suffix: 'km',
          integer: true,
        },
        validations: [{
          type: 'blank',
        }],
        rules: REPEATING_RULES.ALWAYS_VISIBLE,
      },

      zero_km: {
        group: GROUPS.INFORMATION,
        label: 'Financiar como 0km?',
        description: 'Financiar como 0km?',
        validations: [{
          type: 'inclusion',
          list: ['true', 'false'],
        }],
        options: BOOLEAN,
        rules: reduce(BANK_CODES, [
          [{ rule: 'less_than', field: 'vehicle[km_mileage]', count: MAX_ZERO_KM_MILEAGLE }],
        ]),
      },

      color_id: {
        group: GROUPS.INFORMATION,
        label: 'Cor',
        description: 'Selecione',
        domain: 'vehicle_color',
        validations: [{
          type: 'blank',
        }],
        rules: REPEATING_RULES.ALWAYS_VISIBLE,
      },

      chassi_code: {
        group: GROUPS.EXTRA,
        label: 'Chassi',
        description: '9 BR XX99A9 9 A999999',
        validations: [{
          type: 'chassis',
        }],
        rules: REPEATING_RULES.ALWAYS_VISIBLE,
      },
      renavam_code: {
        group: GROUPS.EXTRA,
        label: 'Renavam',
        description: '99999999999',
        validations: [{
          type: 'renavam',
        }],
        rules: REPEATING_RULES.ALWAYS_VISIBLE,
      },

      external_ad_link: {
        group: GROUPS.EXTRA,
        label: 'Link do anúncio em outro site',
        description: 'Exemplo: https://www.webmotors.com.br/seu-anuncio-aqui',
        validations: [],
        rules: REPEATING_RULES.ALWAYS_VISIBLE,
      },

      publish: {
        group: GROUPS.PICTURES,
        label: 'Publicar no showroom digital?',
        description: 'Mostrar veículo no simulador público?',
        validations: [{
          type: 'inclusion',
          list: ['true', 'false'],
        }],
        options: BOOLEAN,
        rules: REPEATING_RULES.ALWAYS_VISIBLE,
      },

      description: {
        group: GROUPS.PICTURES,
        label: 'Descrição do veículo',
        description: 'Informações do seu veículo usado',
        rules: REPEATING_RULES.ALWAYS_VISIBLE,
        type: 'markdown',
      },

      pictures: {
        group: GROUPS.PICTURES,
        label: GROUPS.PICTURES.title,
        description: GROUPS.PICTURES.subtitle,

        fields: Array.from(new Array(ATTACHMENTS_COUNT), attachment),
      },
    },
  },
};
